import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { ApiResult } from '@/infra/api'
import { apiKeyClient } from '../api/client'
import { API_KEY_QUERY_KEYS } from '../api/queryKeys'
import type { ApiKeyGenerationRequest, ApiKeyResponse } from '../types'

export interface UseApiKeyGenerationReturn {
  readonly generate: (request: ApiKeyGenerationRequest) => void
  readonly generateAsync: (request: ApiKeyGenerationRequest) => Promise<ApiResult<ApiKeyResponse>>
  readonly isGenerating: boolean
  readonly error: string | null
  readonly generatedKey: ApiKeyResponse | null
  readonly reset: () => void
}

export function useApiKeyGeneration(): UseApiKeyGenerationReturn {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: apiKeyClient.generateApiKey,
    onSuccess: (result) => {
      if (result.success) {
        void queryClient.invalidateQueries({ queryKey: API_KEY_QUERY_KEYS.list() })
        void queryClient.invalidateQueries({ queryKey: ['settings', 'apiKeys'] })
      }
    },
  })

  return {
    generate: mutation.mutate,
    generateAsync: mutation.mutateAsync,
    isGenerating: mutation.isPending,
    error: mutation.data?.success === false ? mutation.data.message : null,
    generatedKey: mutation.data?.success ? mutation.data.data : null,
    reset: mutation.reset,
  }
}
